/**
 * Pack shop (sections/pack-shop.liquid): the subscribe switch flips every
 * card between one-time and plan prices and enables the hidden selling_plan
 * field in each card's form, so Horizon's product form adds the chosen mode.
 */
class PackShop extends HTMLElement {
  connectedCallback() {
    this.switch = this.querySelector('[data-subscribe-switch]');
    if (!this.switch) return;
    this.onChange = () => this.update();
    this.switch.addEventListener('change', this.onChange);
    this.update();
  }

  disconnectedCallback() {
    this.switch?.removeEventListener('change', this.onChange);
  }

  update() {
    const on = this.switch.checked;
    this.toggleAttribute('data-subscribed', on);
    this.switch.setAttribute('aria-checked', String(on));
    this.querySelectorAll('[data-selling-plan-field]').forEach((field) => {
      field.disabled = !on;
    });
  }
}

if (!customElements.get('pack-shop')) customElements.define('pack-shop', PackShop);
